import React from 'react';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';
import {
  FDHeadlineText, FDLozenge, FDStack, FDBox, FDSecondaryActionButton,
} from '@facet-wealth/design';
import MetaControl from 'Components/UI/Meta/MetaControl';
import {
  UpgradeOfferListItem,
} from 'Views/FreemiumEntry/HasRelationship/Content/Templates/InsightUpgrade/UpgradeOffer/UpgradeOfferItem';
import fr from 'facet-rest';
import useMobileLayout from 'Hooks/useMobileLayout';
import useEventTrackingLogEvent, { categories, eventSubTypes, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import { useBuildCommonFQEventProperties } from 'Views/FreemiumEntry/HasRelationship/Content/Components/utils';

const metaOverrides = buildFacetDesignOverride()
  .nameOverride('rackPrice', {
    _component: () => Richtext,
    _customProps: {
      Component: FDHeadlineText,
      size: 'sm',
    },
  }, overrideReadOnly)
  .nameOverride(['offerTitle'], {
    _component: () => FDHeadlineText,
    _customProps: {
      size: 'lg',
    },
  }, overrideReadOnly);

const UpgradeOfferSecondary = ({ resource, onClickUpgrade, loading }) => {
  const [isExpanded, setIsExpanded] = React.useState(false);
  const isMobile = useMobileLayout();
  const { logStandardizedEvent } = useEventTrackingLogEvent();
  const { buildCommonFQEventProperties } = useBuildCommonFQEventProperties();

  return (
    <FDStack direction={'column'} spacing={4}>
      <FDStack direction={'column'} spacing={2}>
        {resource.attr('headerText') ? <FDLozenge color={'success'} label={resource.attr('headerText')} /> : null}
        <MetaControl attrName={'offerTitle'} metaOverrideSet={metaOverrides} resource={resource} />
        <MetaControl attrName={'offerDescription'} metaOverrideSet={metaOverrides} resource={resource} />
        <FDStack direction={'row'} spacing={1} alignItems={'center'} justifyContent={'flex-start'}>
          <MetaControl attrName={'rackPrice'} metaOverrideSet={metaOverrides} resource={resource} />
          <FDLozenge color={'info'} size={'sm'} label={resource.attr('savingsAmount')} />
        </FDStack>
      </FDStack>
      {isExpanded && resource.attr('listItems') && (
        <FDStack direction={'column'} spacing={2}>
          {resource.attr('listItems')?.resources().list().map((item) => <UpgradeOfferListItem key={item.id()} item={item} />)}
        </FDStack>)}
      <FDStack direction={'column'} spacing={2} alignItems={'center'} justifyContent={'center'}>
        {!isExpanded && resource.attr('learnMoreLabel') && <FDSecondaryActionButton
          onClick={() => {
            setIsExpanded(true);
            logStandardizedEvent(categories.facetQuiz, eventTypes.insight, eventSubTypes.clickedCTA, {
              eventProperties: {
                ...buildCommonFQEventProperties(resource),
                insightId: resource.attr('insightId'),
                insightReferenceName: resource.attr('insightReferenceName'),
                action: 'clicked-learn-more',
              },
            });
          }}
          label={resource.attr('learnMoreLabel')}
        />}
        {isExpanded && resource.withRelationship(fr.relationships.upgradeForAmount.name, (rel) => (
          <FDBox width={'100%'}>
            <FDSecondaryActionButton
              loading={loading}
              onClick={() => {
                logStandardizedEvent(categories.facetQuiz, eventTypes.insight, eventSubTypes.clickedCTA, {
                  eventProperties: {
                    ...buildCommonFQEventProperties(resource),
                    insightId: resource.attr('insightId'),
                    insightReferenceName: resource.attr('insightReferenceName'),
                    action: 'upgrade-now-for-amount',
                    isSecondary: true,
                  },
                });
                onClickUpgrade(rel);
              }}
              label={rel.meta('prompt')}
              isFullWidth={isMobile}
            />
          </FDBox>
        ), () => null)}
      </FDStack>
    </FDStack>
  );
};

export { UpgradeOfferSecondary };
